import axios from 'axios'
import  { checkErrorData } from './authAction'
import  { formatList, orderByDateDsc } from './format'

export function newSpending(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_SPENDING_START", payload: "" })

            console.log("new Spending START", {data})
            const res = await axios.post('/spendings/new',{data})
            console.log({res});
            
            if(checkErrorData(res, "CREATE_SPENDING_ERROR", dispatch ) ) {
                dispatch({ type: "NEW_SPENDING", payload: res.data })
				dispatch({ type: "CREATE_SPENDING_FULFILLED", payload: "" })
            }

            // if (!res.data){
            //     dispatch({
            //         type: "CREATE_SPENDING_ERROR",
            //         payload: "Pas de réponse"
            //     })
            // } else if (res.data.error){
            //     dispatch({
            //         type: "CREATE_SPENDING_ERROR",
            //         payload: res.data.error.message
            //     })
            //     console.log("ERROR", res.data.error);
            // } else {
            //     // dispatch(checkError(res.data.error))
                
			// 	dispatch({ type: "NEW_SPENDING", payload: res.data })
			// 	dispatch({ type: "CREATE_SPENDING_FULFILLED", payload: "" })
			// }
        } catch(err) {
            console.log("[ERROR] new spending ", err);
            dispatch({
                type: "CREATE_SPENDING_ERROR",
                payload: err
            })
        }
    }
}
export function fetchUserSpendings() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_USER_SPENDINGS_START", payload: "" })
            console.log("fetch Spending START")
            const res = await axios.get('/spendings/user/get/all')
            console.log({res});
            if(checkErrorData(res, "FETCH_USER_SPENDINGS_ERROR", dispatch ) ) {
                dispatch({
                    type: "GET_USER_SPENDINGS",
                    payload: formatList(orderByDateDsc(res.data, "spending_date"), "spending_id")
                })
                dispatch({ type: "FETCH_USER_SPENDINGS_FULFILLED", payload: "" })
            }
            
            // if (!res.data.error){
            // } else {
			// 	console.log("ERROR", res.data.error);
			// 	dispatch(checkError(res.data.error))
				
			// }
        } catch(err) {
            console.log("[ERROR] get spendings list ", err);
            dispatch({
                type: "FETCH_USER_SPENDINGS_ERROR",
                payload: err
                
            })
        }
    }
}
export function fetchAdminSpendings() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_ADMIN_SPENDINGS_START", payload: "" })

            console.log("fetch Spending START")
            const res = await axios.get('/spendings/admin/get/all')
            console.log({res});

            if(checkErrorData(res, "FETCH_ADMIN_SPENDINGS_ERROR", dispatch ) ) {
                dispatch({
                    type: "GET_ADMIN_SPENDINGS",
                    payload: formatList(orderByDateDsc(res.data, "spending_date"), "spending_id")
                    
                })
                dispatch({ type: "FETCH_ADMIN_SPENDINGS_FULFILLED", payload: "" })
            }
            // if (!res.data.error){
            //     dispatch({
            //         type: "GET_ADMIN_SPENDINGS",
            //         payload: formatList(res.data, "spending_id")
            //     })
            // } else {
			// 	console.log("ERROR", res.data.error);
			// 	dispatch(checkError(res.data.error))
				
			// }
        } catch(err) {
            console.log("[ERROR] get spendings list ", err);
            dispatch({
                type: "FETCH_ADMIN_SPENDINGS_ERROR",
                payload: err
                
            })
        }
    }
}

export function fetchSpendingPayments(spendingID) {
    return async function(dispatch){
        try {
            dispatch({ type: "FETCH_SPENDING_PAYMENTS_START", payload: "" })

            console.log("fetch Spending START")
            const res = await axios.post('/spendings/payments/get/all',  {data: spendingID})
            console.log({res});

            if(checkErrorData(res, "FETCH_SPENDING_PAYMENTS_ERROR", dispatch ) ) {
                dispatch({
                    type: "GET_SPENDING_PAYMENTS",
                    payload: {spendingID, payments: res.data}
                })
                dispatch({ type: "FETCH_SPENDING_PAYMENTS_FULFILLED", payload: "" })
            }
        } catch(err) {
            console.log("[ERROR] get spendings list ", err);
            dispatch({
                type: "FETCH_SPENDING_PAYMENTS_ERROR",
                payload: err
                
            })
        }
    }
}
export function updateSpending(data) {
    return async function(dispatch, getState){
        try{
            dispatch({ type: "UPDATE_SPENDING_START", payload: "" })

            console.log("update Spending START")
            const res = await axios.post("/spendings/update", {data})
            console.log({res});

            if(checkErrorData(res, "UPDATE_SPENDING_ERROR", dispatch ) ) {
                let userID = getState().auth.user.id
                dispatch({
                    type: "UPDATE_SPENDING",
                    payload: {data, userID}
                })
                dispatch({ type: "UPDATE_SPENDING_FULFILLED", payload: "" })
            }
           
        } catch(err) {
            console.log("[ERROR] update spending ", err);
            dispatch({
                type: "UPDATE_SPENDING_ERROR",
                payload: err
                
            })
        }
    }
}
export function deleteSpending(data) {
    return async function(dispatch, getState){
        try{
            dispatch({ type: "DELETE_SPENDING_START", payload: "" })

            console.log("delete Spending START")
            const res = await axios.post("/spendings/delete", {data: data.spending_id})
            console.log({res});

            if(checkErrorData(res, "DELETE_SPENDING_ERROR", dispatch ) ) {
                let userID = getState().auth.user.id
                dispatch({
                    type: "DELETE_SPENDING",
                    payload: {data, userID}
                })
                dispatch({ type: "DELETE_SPENDING_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] delete spending ", err);
            dispatch({
                type: "DELETE_SPENDING_ERROR",
                payload: err
            })
        }
    }
}
export function updateFetchSpending(spendingID) {
    return async function(dispatch, getState){
        try{
            dispatch({ type: "UPDATE_FETCH_SPENDING_START", payload: "" })

            console.log("update Spending START")
            const res = await axios.post("/spendings/single", {spendingID})
            console.log({res});

            let userID = getState().auth.user.id
            
            if(checkErrorData(res, "UPDATE_FETCH_SPENDING_ERROR", dispatch ) ) {
                dispatch({
                    type: "UPDATE_FETCH_SPENDING",
                    payload: {data: res.data, userID}
                })
                dispatch({ type: "UPDATE_FETCH_SPENDING_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] update spending ", err);
            dispatch({
                type: "UPDATE_FETCH_SPENDING_ERROR",
                payload: err
                
            })
        }
    }
}

export function updateUserSpending(data) {
    return async function(dispatch, getState){
        try{
            dispatch({ type: "UPDATE_SPENDING_START", payload: "" })

            console.log("update Spending START")
            const res = await axios.post("/spendings/user/update", {data})
            console.log({res});
            
            if(checkErrorData(res, "UPDATE_SPENDING_ERROR", dispatch ) ) {
                let userID = getState().auth.user.id
                dispatch({
                    type: "UPDATE_SPENDING",
                    payload: {data, userID}
                })
                dispatch({ type: "UPDATE_SPENDING_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] update spending ", err);
            dispatch({
                type: "UPDATE_SPENDING_ERROR",
                payload: err
                
            })
        }
    }
}
